import React, { Component } from "react"
import PropTypes from "prop-types"
import { Row, Col, Card, CardBody } from "reactstrap"
import { Link, withRouter  } from "react-router-dom"
import gridView from "../../../assets/img/grid-view.png"
import engagementView from "../../../assets/img/engagement-view.png"
import statusView from "../../../assets/img/status-view.png"
import typeView from "../../../assets/img/type-view.png"
import clientCircle from "../../../assets/img/client-circle-icon.png"

class FilterMenuContact extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  isActive(path) {
    return this.props.location.pathname === path ? "active" : ""
  }
  render() {
    return (
        <React.Fragment>           
        <Row className="">
          <Col sm="12">
            <div className="">
              <div className="btn-group rl-group-btn d-none d-md-flex" role="group">
                <Link to="/all-contacts">
                  <button
                    type="button"
                    className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/all-contacts")}`}
                  >
                    <span className="d-flex align-items-center gap-2">
                    
                    All Contacts

                    <img src={gridView} style={{height:16}} />
                    </span>
                  </button>
                </Link>
                <Link to="/contact/classification-view">
                  <button
                    type="button"
                    className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/contact/classification-view")}`}
                  >
                     <span className="d-flex align-items-center gap-2">
                       
                    Classification View
                    <img src={engagementView} style={{height:16}} />
                  
                    </span>
                  </button>
                </Link>
                <Link to="/contact/activity">
                  <button
                    type="button"
                    className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/contact/activity")}`}
                  >
                      <span className="d-flex align-items-center gap-2">
                        Connect Frequency
                    <img src={statusView} style={{height:16}} />
                   
                    </span>
                  </button>
                </Link>
                 <Link to="/contact/referals">
                  <button
                    type="button"
                    className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/contact/referals")}`}
                  >
                     <span className="d-flex align-items-center gap-2">
                    <img src={typeView} style={{height:16}} />
                    
                    Referrals
                    </span>
                  </button>
                </Link>

                
                 
                
              
               
              </div>

                <div className="d-block d-md-none mt-2">
          <label className="form-label fw-bold mb-1">Select View</label>
        <select
          className="form-select"
          value={this.props.location.pathname} // highlight active
          onChange={(e) => this.props.history.push(e.target.value)}
        >
          <option value="/all-contacts">Active conatcts</option>
          <option value="/contact/classification-view">Classification View</option>
          <option value="/contact/activity">Connect Frequency</option>
          <option value="/contact/referals">Referrals</option>
  
        </select>
      </div>
            </div>     
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}
FilterMenuContact.propTypes = {

    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired
    }).isRequired,
    history: PropTypes.object
  }
export default withRouter(FilterMenuContact)
